import {Grid, List, ListItem} from "@mui/material";
import React from "react";
import {useCustomsRequirementsList} from "~/apps/packages/customs-requirements/hooks";
import {CustomsRequirementItem} from "~/apps/packages/customs-requirements/components/CustomsRequirementItem";
import {CustomsRequirement} from "~/apps/packages/customs-requirements/queries";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";



export type CustomsRequirementListProp = {
    query?: string
    dateRange?: [Date, Date]
    type?: CustomsRequirement["screeningType"]
}


export const CustomsRequirementList = (props: CustomsRequirementListProp) => {
    const {query, dateRange, type} = props;
    const {data, loading, fetchMore, canFetchMore} = useCustomsRequirementsList({
        query: query,
        dateRange: dateRange,
        screeningType: type
    });

    const setScrollableNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    const handleRef = (node) => {
        setScrollableNode(findScrollableNode(node));
    }

    return (
        <LoadingBox isInitialLoading={data == undefined} loading={loading} empty={data?.length == 0} placeholder={canFetchMore}>
            {data?.length > 0 && (
                <List ref={handleRef}>
                    {data.map(item => (
                        <ListItem key={item.number}>
                            <CustomsRequirementItem customsRequirement={item}/>
                        </ListItem>
                    ))}
                </List>
            )}
        </LoadingBox>
    );
}